module.exports = __webpack_public_path__ + "static/media/4.fd109e1b.jpg";